var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "IconL-bell",
    x: 0.163,
    y: 0.865,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.154,22.865c-1.158,0 -2.157,-0.804 -2.373,-1.876l4.745,0c-0.216,1.071 -1.215,1.876 -2.372,1.876Zm8.727,-5.01c-0,0 -0,0 -0,0c0.178,0.187 0.259,0.41 0.257,0.629c0,0 0,0 0,0c-0.003,0.485 -0.394,0.941 -0.971,0.941c0,0 -16.008,0 -16.008,0c-0.577,0 -0.968,-0.457 -0.971,-0.941c-0.002,-0.219 0.08,-0.442 0.257,-0.629c0.898,-0.944 2.064,-2.194 2.064,-6.847c-0,-3.156 2.267,-5.678 5.316,-6.298c0.213,-0.043 0.363,-0.23 0.363,-0.443l-0,-0.464c-0,-0.52 0.434,-0.938 0.966,-0.938c0.531,0 0.966,0.418 0.966,0.938l-0,0.464c-0,0.213 0.15,0.4 0.363,0.443c3.049,0.62 5.316,3.142 5.316,6.298c-0,4.653 1.184,5.903 2.082,6.847Zm-14.149,-6.799c-0.009,3.533 -0.457,5.296 -1.359,6.459c-0.107,0.139 -0.373,0.433 -0.302,0.575c0.077,0.154 0.198,0.154 0.661,0.154c0.358,0 3.493,0 12.862,0c0.381,0 0.605,0.03 0.668,-0.154c0.06,-0.172 -0.07,-0.235 -0.309,-0.575c-0.881,-1.251 -1.367,-2.923 -1.377,-6.453l0.002,-0.054c0,-2.935 -2.426,-5.318 -5.424,-5.318c-2.999,0 -5.425,2.383 -5.425,5.318c0,0.013 0.002,0.032 0.003,0.048Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLBell);
export default __webpack_public_path__ + "static/media/iconL-bell.ed3c3809f6d6449f5d7d83b74ae79546.svg";
export { ForwardRef as ReactComponent };